import {Pipe, PipeTransform} from '@angular/core';
import {Breakpoints} from '@angular/cdk/layout';

@Pipe({
    name: 'sizeBool',
    standalone: false
})
export class SizeStringToBoolPipe implements PipeTransform {
    transform(value: string, cutOffPoint: string): any {
        let test: string[] = [];
        switch (cutOffPoint) {
            case Breakpoints.XSmall:
                test = ["(min-width: 1920px)",
                        "(min-width: 1280px) and (max-width: 1919.98px)",
                        "(min-width: 960px) and (max-width: 1279.98px)",
                        "(min-width: 600px) and (max-width: 959.98px)",
                        "(max-width: 599.98px)"]
                break;
            case Breakpoints.Small:
                test = ["(min-width: 1920px)",
                        "(min-width: 1280px) and (max-width: 1919.98px)",
                        "(min-width: 960px) and (max-width: 1279.98px)",
                        "(min-width: 600px) and (max-width: 959.98px)"]
                break;
            case Breakpoints.Medium:
                test = ["(min-width: 1920px)",
                        "(min-width: 1280px) and (max-width: 1919.98px)",
                        "(min-width: 960px) and (max-width: 1279.98px)"]
                break;
            case Breakpoints.Large:
                test = ["(min-width: 1920px)",
                        "(min-width: 1280px) and (max-width: 1919.98px)"]
                break;
            case Breakpoints.XLarge:
                test = ["(min-width: 1920px)"]
                break;
        }
        return test.includes(value)
    }

}